import { useState, useEffect } from 'react';
import { Department, Block } from '../../types/data';
import Row from '../row/row';
import { calculatesAverageValue, getDateAsString } from '../../utils/utils';
import { AdditionalInformation, QuarterDictionary } from '../../types/data';
import { arrow } from "../../../vpo/ui-icons/icons";
import { Quarter } from '../../types/data';
import { PlanActionsContext } from '../../types/types';
import { TooltipItem } from "src/utils/Tooltip";
import { useSearchParams } from 'react-router-dom';

const COLUMNS = {
  '1': {
    width: '600px',
    indent: '0',
  },
  '2': {
    width: '60px',
    indent: '0',
  },
  '3': {
    width: '70px',
    indent: '60px',
  },
  '4': {
    width: '70px',
    indent: '130px',
  },
  '5': {
    width: '120px',
    indent: '200px',
  },
  '6': {
    width: '170px',
    indent: '320px',
  },
};

type RowBlockProps = Block & {
  departments: Department[];
  showContent?: boolean;
  factory: number;
  quarter: Quarter;
  year: number;
  gop?: string;
  group?: number;
  direction?: number;
  gopId?: number;
  isNotEditQuestionnaire?: boolean;
  onOpenModal?: (data?: AdditionalInformation) => void;
  onCreateQuestionnaire?: () => void;
  context?: PlanActionsContext;
  isFactory?: boolean;
  completedAssessment?: string;
  completionDate?: string;
};

function RowBlock(props: RowBlockProps) {
  const { title, departments, groupRequirements, showContent, factory, quarter, year, gop, group, direction, gopId, isNotEditQuestionnaire, onOpenModal, onCreateQuestionnaire, context, isFactory, completedAssessment, completionDate } = props;

  const [isOpen, setIsOpen] = useState(false);
  const [searchParams] = useSearchParams();

  const handleToggleChange = () => {
    if (isFactory) return;

    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (showContent) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [showContent]);

  useEffect(() => {
    setIsOpen(false);
  }, [factory]);

  useEffect(() => {
    const actionCardId = searchParams.get('actionCardGOP');

    if (actionCardId) {
      const hasMatchingAction = groupRequirements.some(requirement =>
        requirement.actions && requirement.actions.includes(actionCardId)
      );

      if (hasMatchingAction) {
        setIsOpen(true);
      }
    }
  }, [searchParams, groupRequirements]);

  return (
    <>
      <tr>
        {!isFactory &&
          <td
            className="sticky z-10 border border-gray-400 bg-white px-2.5 py-2 text-xs before:absolute before:right-[-1px] before:top-0 before:block before:h-full before:w-[1px] before:bg-gray-400"
            style={{
              left: COLUMNS['1'].indent,
              width: `${COLUMNS['1'].width}`,
            }}
            onClick={handleToggleChange}
          >
            <div className={`text-sm ${isOpen ? 'opacity-100' : 'opacity-50'}`}>
              {title}
            </div>

            <div
              className={`absolute right-3 top-[50%] translate-y-[-50%] cursor-pointer ${isOpen && 'rotate-180'}`}
            >
              <TooltipItem className={`${isOpen ? 'rotate-180 translate-x-[-140%]' : ''}`} position="right" tooltipsText={isOpen ? 'Свернуть' : 'Развернуть'}>
                {arrow}
              </TooltipItem>
            </div>
          </td>
        }

        {isFactory && (
          <>
            <td
              className="sticky z-10 border border-gray-400 bg-white px-2.5 py-2 text-xs before:absolute before:right-[-1px] before:top-0 before:block before:h-full before:w-[1px] before:bg-gray-400"
              style={{
                left: COLUMNS['2'].indent,
                width: `${COLUMNS['2'].width}`,
              }}
            >
              {year}
            </td>

            <td
              className="sticky z-10 border border-gray-400 bg-white px-2.5 py-2 text-xs before:absolute before:right-[-1px] before:top-0 before:block before:h-full before:w-[1px] before:bg-gray-400"
              style={{
                left: COLUMNS['3'].indent,
                width: `${COLUMNS['3'].width}`,
              }}
            >
              {QuarterDictionary[quarter]} кв.
            </td>

            <td
              className="sticky z-10 border border-gray-400 bg-white px-2.5 py-2 text-xs before:absolute before:right-[-1px] before:top-0 before:block before:h-full before:w-[1px] before:bg-gray-400"
              style={{
                left: COLUMNS['4'].indent,
                width: `${COLUMNS['4'].width}`,
              }}
            >
              {factory}
            </td>

            <td
              className="sticky z-10 border border-gray-400 bg-white px-2.5 py-2 text-xs before:absolute before:right-[-1px] before:top-0 before:block before:h-full before:w-[1px] before:bg-gray-400"
              style={{
                left: COLUMNS['5'].indent,
                width: `${COLUMNS['5'].width}`,
              }}
            >
              {gop}
            </td>

            <td
              className="sticky z-10 border border-gray-400 bg-white px-2.5 py-2 text-xs before:absolute before:right-[-1px] before:top-0 before:block before:h-full before:w-[1px] before:bg-gray-400"
              style={{
                left: COLUMNS['6'].indent,
                width: `${COLUMNS['6'].width}`,
              }}
              onClick={handleToggleChange}
            >
              <div className="text-sm font-medium overflow-hidden text-ellipsis whitespace-nowrap pl-2">
                {title}
              </div>
            </td>
          </>
        )}

        {departments.map((el) => (
          <td
            key={el.id}
            className="border border-gray-400 px-2.5 py-2 text-center text-xs"
          >
            {calculatesAverageValue(groupRequirements, el.title)}
            {Number.isInteger(calculatesAverageValue(groupRequirements, el.title)) &&
              '%'}
          </td>
        ))}

        <td className="border border-gray-400 px-2.5 py-2 text-center text-xs">
          {calculatesAverageValue(groupRequirements, undefined, true)}
          {calculatesAverageValue(groupRequirements, undefined, true) !==
            'N/A' && '%'}
        </td>

        {isFactory
          ?
            <>
              <td className="border border-gray-400 px-2.5 py-2 text-center text-xs">{completedAssessment}</td>
              <td className="border border-gray-400 px-2.5 py-2 text-center text-xs">{completionDate}</td>
            </>
          :
            <>
              <td className="border border-gray-400 px-2.5 py-2 text-center text-xs"></td>
              <td className="border border-gray-400 px-2.5 py-2 text-center text-xs"></td>
            </>
        }
      </tr>

      {isOpen &&
        groupRequirements.map((requirement, index) => (
          <Row
            key={index}
            {...requirement}
            factory={factory}
            quarter={quarter}
            year={year}
            group={group}
            direction={direction}
            gopId={gopId}
            isNotEditQuestionnaire={isNotEditQuestionnaire as boolean}
            onOpenModal={onOpenModal}
            onCreateQuestionnaire={onCreateQuestionnaire}
            context={{
              ...context,
              currentRequirement: {
                id: requirement.requirementId,
                title: requirement.title,
                isFocal: requirement.isFocal,
              },
            }}
          />
        ))}
    </>
  );
}

export default RowBlock;
